let isWX = global.__wxjs_environment === 'miniprogram'; // 判断是否小程序;
try {
    global.wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
            isWX = res.miniprogram;
        }
    });
} catch (e) {
}
export default isWX;
